<template>
  <div class="settings-layout">
    <div class="tab-options">
      <router-link v-for="(data, index) in options" :key="index" :to="({name: data.route})">
        {{data.name}}
        <span v-if="data.total">({{data.total}})</span>
      </router-link>
    </div>

    <div class="menu" :class="{'card-list': ['PastEvents', 'UpcomingEvents'].includes($route.name)}">
      <unprivilege-panel v-if="getterUnprivilegePage === 'Settings'" :css="'settings-panel'" />
      <router-view v-else />
    </div>
  </div>
</template>

<script>
import UnprivilegePanel from '@/components/global/UnprivilegePanel'
import { mapGetters } from 'vuex'

export default {
  name: 'SettingsLayout',
  components: { UnprivilegePanel },
  data () {
    return {
      options: []
    }
  },
  watch: {
    '$route': {
      handler: 'updateTabs',
      immediate: true
    },
    getterUpcomingEventsCount () {
      this.updateTabs()
    }
  },
  computed: {
    ...mapGetters(['getterUnprivilegePage', 'getterUpcomingEventsCount'])
  },
  methods: {
    updateTabs () {
      const path = this.$route.path
      if (path.startsWith('/access')) {
        this.options = [
          {
            name: 'Roles',
            route: 'RolesList'
          },
          {
            name: 'Users',
            route: 'UsersList'
          }
        ]
      } else if (path.startsWith('/status')) {
        this.options = [
          {
            name: 'Current Status',
            route: 'LiveEvents'
          },
          {
            name: this.isDesktop() ? 'Events History' : 'History',
            route: 'PastEvents'
          },
          {
            name: this.isDesktop() ? 'Upcoming Events' : 'Upcoming',
            route: 'UpcomingEvents',
            total: this.getterUpcomingEventsCount
          },
          {
            name: this.isDesktop() ? 'Beneficiary Banks' : 'Bene Banks',
            route: 'BeneBankStatus'
          }
        ]
      } else {
        this.options = [
          {
            name: 'Account',
            route: 'AccountSettings'
          },
          {
            name: 'API',
            route: 'ApiSettings'
          },
          {
            name: 'Webhooks',
            route: 'WebhookSettings'
          },
          {
            name: 'User Profile',
            route: 'UserProfileSettings'
          }
        ]
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/scss/tabOptions.scss';

  .settings-layout {
    @include custom-flex(null, null, column);
    flex: 1;
  }

  .menu {
    border-radius: 15px;
  }

  .desktop {
    .menu {
      width: 50%;
      flex: 1;
      overflow: auto;
      background: $white;
      padding: 20px;
    }

    .settings-panel {
      width: unset !important;
    }
  }

  .tablet, .mobile {
    .menu {
      height: 100%;

      &:not(.card-list) {
        background: $white;
        padding: 15px;
        box-shadow: $card-shadow;
      }
    }
  }
</style>
